import { Box, IconButton, Stack, TextField, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { snackbar } from "lib/snackbar"

export function CopyableField({ label, value, snackbarMessage }) {
    if (!value) return null

    return (
        <Box>
            <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 0.5 }}>
                {label}
            </Typography>
            <Stack direction="row" spacing={1} alignItems="center">
                <TextField fullWidth size="small" value={value} InputProps={{ readOnly: true }} />
                <IconButton aria-label="Copy" onClick={handleCopy} size="small">
                    <Iconify icon="eva:copy-fill" />
                </IconButton>
            </Stack>
        </Box>
    )

    function handleCopy() {
        navigator.clipboard.writeText(value)
        snackbar(snackbarMessage)
    }
}
